import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const Overview = wrapSuspenseComponent(loadable(() => import('./Overview')))
const Creation = wrapSuspenseComponent(loadable(() => import('./Creation')))
const Claiming = wrapSuspenseComponent(loadable(() => import('./Claiming')))
const Page = wrapSuspenseComponent(loadable(() => import('./Page')))
const Embeds = wrapSuspenseComponent(loadable(() => import('./Embeds')))

const PresentationsSection = () => (
  <DocsSection section='presentations'>
    <Routes>
      <Route index element={<Overview />} />
      <Route path='overview' element={<Overview />} />
      <Route path='creation' element={<Creation />} />
      <Route path='claiming' element={<Claiming />} />
      <Route path='page' element={<Page />} />
      <Route path='embeds' element={<Embeds />} />
    </Routes>
  </DocsSection>
)

export default PresentationsSection
